import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
const { custom_blue } = variables;

export const BreadCrumbsWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const BreadCrumb = styled('div')`
  display: flex;
  align-items: center;
  .icon-chevron-right {
    padding: 0 10px;
  }
`;

export const BreadCrumbInner = styled('div')``;

export const Text = styled('h3')`
  text-transform: uppercase;
  letter-spacing: 1.1px;
  font-size: 12px;
  font-weight: 500;
  color: #76899e;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
  &:hover {
    color: ${custom_blue};
  }
`;
